export default {
  color: {
    label: 'Color',
    placeholder: 'Add color',
    system: {
      name: 'job_card_color_id',
    },
    value: '',
    errors: [],
    type: 'color',
    name: 'color',
    rules: {
      title: 'Color field',
      required: true,
    }
  },
  default: {
    label: 'Apply as default',
    placeholder: '',
    system: {
      name: 'is_default',
    },
    value: false,
    errors: [],
    type: 'checkbox',
    name: 'default',
    rules: {
      title: '',
    }
  },
  label: {
    label: 'Label',
    placeholder: 'Add label',
    system: {
      name: 'label',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/JobCardAdd/fields.js